import { useState, useEffect } from 'react';

import getConfig from '../config';
import { handleResponseStatus, sendRequest } from '../utils/api-request';
import { runtimeMappings } from '../utils/runtime-mappings';

const { indexerApi } = getConfig();

const useProjectById = (projectId, accountId) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState();
  const [runtimeFields, setRuntimeFields] = useState();

  const showError = () => {
    setIsLoading(false);
    setIsError(true);
  };

  const setProjectData = (response) => {
    const hits = response?.hits?.hits;
    if (!hits?.length) {
      showError();
      return;
    }

    const [{ _source, fields }] = hits;
    setData(_source);
    setRuntimeFields(fields);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!accountId) return;

    (async () => {
      const body = {
        runtime_mappings: { ...runtimeMappings },
        fields: ['currentStage', 'currentVotingStage', 'currentPeriod', 'isStagesFinished', 'isLastValidationBegins'],
        query: {
          bool: {
            must: [
              {
                match: {
                  'project_id.keyword': projectId,
                },
              },
              {
                match: {
                  'signer_id.keyword': accountId,
                },
              },
            ],
          },
        },
      };
      const { result, statusCode } = await sendRequest(indexerApi, 'POST', JSON.stringify(body));
      handleResponseStatus(
        statusCode,
        () => setProjectData(result),
        () => showError(),
      );
    })();
  }, [accountId]);

  return { isError, isLoading, data, runtimeFields };
};

export default useProjectById;
